import baseApi from './base.api'
import { DISCOVERY_COMPONENT_TAG, CONCEPTUAL_LABEL_TAG } from './utils/tags'
import {
    handleCreateComponentOnQueryStarted,
    handleUpdateComponentOnQueryStarted,
    handleDeleteComponentOnQueryStarted,
} from './utils/response-handlers/discovery.api.response.handlers'

export const discoveryComponentApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        createDiscoveryComponent: builder.mutation({
            query: ({ token, name, order = 0 }) => ({
                url: `/discovery-components/${token}`,
                method: 'POST',
                body: { name, order },
            }),
            onQueryStarted: handleCreateComponentOnQueryStarted,
            invalidatesTags: [
                { type: DISCOVERY_COMPONENT_TAG, id: 'LIST' },
                { type: CONCEPTUAL_LABEL_TAG, id: 'DISCOVERY' }
            ],
        }),
        updateDiscoveryComponent: builder.mutation({
            query: ({ componentId, name, order }) => ({
                url: `/discovery-components/${componentId}`,
                method: 'PATCH',
                body: { name, order },
            }),
            onQueryStarted: handleUpdateComponentOnQueryStarted,
            invalidatesTags: (result, error, { componentId }) => [
                { type: DISCOVERY_COMPONENT_TAG, id: componentId },
                { type: DISCOVERY_COMPONENT_TAG, id: 'LIST' },
                { type: CONCEPTUAL_LABEL_TAG, id: 'DISCOVERY' }
            ],
        }),
        deleteDiscoveryComponent: builder.mutation({
            query: ({ componentId }) => ({
                url: `/discovery-components/${componentId}`,
                method: 'DELETE',
            }),
            onQueryStarted: handleDeleteComponentOnQueryStarted,
            invalidatesTags: (result, error, { componentId }) => [
                { type: DISCOVERY_COMPONENT_TAG, id: componentId },
                { type: DISCOVERY_COMPONENT_TAG, id: 'LIST' },
                { type: CONCEPTUAL_LABEL_TAG, id: 'DISCOVERY' }
            ],
        }),
    }),
})

export const {
    useCreateDiscoveryComponentMutation,
    useUpdateDiscoveryComponentMutation,
    useDeleteDiscoveryComponentMutation,
} = discoveryComponentApi